<header class="header">
  <ng-content select="[header]"></ng-content>
</header>
<div *ngIf="sidebarVisible" (click)="onBackdropClick()" class="backdrop"></div>
<aside
  [class.sidebar--visible-on-mobile]="sidebarVisible"
  [class.sidebar--hidden-on-mobile]="!sidebarVisible"
  class="sidebar"
>
  <svg-icon-sprite
    [src]="'./assets/img/icons/sprite.svg#corner'"
    class="corner"
  />
  <ng-content select="[sidebar]"></ng-content>
  <svg-icon-sprite
    [src]="'./assets/img/icons/sprite.svg#corner'"
    class="corner corner--bottom"
  />
</aside>
<div [class.content-wrapper--darkened]="sidebarVisible" class="content-wrapper">
  <div class="content">
    <ng-content select="[content]"></ng-content>
  </div>
</div>
